<template>
  <TransitionRoot as="template" :show="modelValue">
    <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" :open="modelValue">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                         leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div
            class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-40"
            @click="close">
          <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
               viewBox="0 0 18 18">
            <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
          </svg>
          <span class="text-sm">(Esc)</span>
        </div>
        <TransitionChild as="template" enter="ease-out duration-300"
                         enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                         enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                         leave-from="opacity-100 translate-y-0 sm:scale-100"
                         leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
              class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <!-- overflow-hidden -->
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <slot name="left"></slot>
                <!--                <div
                                    class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                  <ExclamationIcon class="h-6 w-6 text-red-600" aria-hidden="true"/>
                                </div>-->
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    <slot name="title">Заголовок окна</slot>
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      <slot name="sub-title"/>
                    </p>
                    <slot></slot>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button type="button" v-show="okShow" :class="cls" @click="clickOk">
                {{ okText }}
              </button>
              <button type="button"
                      class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      @click="close" ref="cancelButtonRef">
                Отмена
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'

export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,

  },
  /*  setup(props) {
      let colors = {
        'red': 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
        'primary': 'bg-primary-600 hover:bg-primary-700 focus:ring-primary-500',
        'green': 'bg-green-600 hover:bg-green-700 focus:ring-green-500',
      }
      let ok = {
        show: false,
        text: '',
        cls: ''
      }
      if (props['okBtn'].text.length > 1) {
        ok.show = true;
        ok.text = props['okBtn'].text;
        ok.cls = colors[props['okBtn'].color ? props['okBtn'].color : 'primary']
      }

      return {
        ok
      }
    },*/
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    okText: {
      default: ''
    },
    okColor: {
      default: 'primary'
    }
  },
  emits: ['ok', 'update:modelValue'],

  watch: {
    modelValue(value) {
      if (value) document.addEventListener("keydown", this.escEvent);
      else document.removeEventListener('keydown', this.escEvent)
    }
  },
  methods: {
    clickOk() {
      this.$emit('ok', true);
    },
    close() {
      this.$emit('update:modelValue', false);
    },
    escEvent(e) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
  },
  computed: {
    cls() {
      return {
        'w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm': true,
        'bg-red-600 hover:bg-red-700 focus:ring-red-500': this.okColor === 'red',
        'bg-primary-600 hover:bg-primary-700 focus:ring-primary-500': this.okColor === 'primary',
        'bg-green-600 hover:bg-green-700 focus:ring-green-500': this.okColor === 'green'
      }
    },
    okShow() {
      return this.okText.length > 0;
    }
  }
}
</script>